import { render, staticRenderFns } from "./ListarTurmaPageAEE.vue?vue&type=template&id=f30a10dc"
import script from "./ListarTurmaPageAEE.vue?vue&type=script&lang=js"
export * from "./ListarTurmaPageAEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports